import { render, staticRenderFns } from "./SingularityCanvasOption.vue?vue&type=template&id=3b79f03a&"
import script from "./SingularityCanvasOption.vue?vue&type=script&lang=ts&"
export * from "./SingularityCanvasOption.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports